/** @prettier */
import * as provider from './providers/umami';

/**
 * Loads the analytics provider for the current site
 * @param {String} siteId The ID of the site in the analytics provider
 */
export const loadAnalytics = (siteId) => {
  try {
    provider.load(siteId);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Could not load collector', e);
  }
};

/**
 * Tracks a custom event in the analytics provider
 * @param {String} name The name of the event
 * @param {Object} data Any properties to track with the event
 */
export const trackEvent = (name, data) => {
  try {
    provider.track(name, data);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Could not send collector event', e);
  }
};
